// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"41803862","977":"5c189954"}[chunkId] + ".chunk.js";
};